export default function EmojiSleep({ color = "#3E3E3E", width = "24", height = "24" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M17.3033 6.6967C20.2322 9.62563 20.2322 14.3744 17.3033 17.3033C14.3743 20.2322 9.62562 20.2322 6.6967 17.3033C3.76777 14.3743 3.76777 9.62562 6.6967 6.6967C9.62563 3.76777 14.3744 3.76777 17.3033 6.6967"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.1665 9.7001C15.8373 10.1043 15.3873 10.3334 14.9165 10.3334C14.4457 10.3334 14.0082 10.1043 13.6665 9.7001"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.3333 9.7001C10.0041 10.1043 9.55409 10.3334 9.08325 10.3334C8.61242 10.3334 8.17492 10.1043 7.83325 9.7001"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.9166 14.24C14.9166 14.24 13.8224 15.3333 11.9999 15.3333C10.1766 15.3333 9.08325 14.24 9.08325 14.24"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
